import { isLoggedIn } from '../../utils/auth'
import { injectReducer } from '../../store/reducers'

const SinglePurchaseClusteringRoute = (store) => ({
  path: 'single-purchases-clustering-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const ClusteringComponent = require('./containers/SinglePurchasesClusteringContainer.js').default
      const {loadAnalysisResultReducer} = require('./modules/Clustering')
      injectReducer(store, {key: 'analysisResult', reducer: loadAnalysisResultReducer})
      callback(null, ClusteringComponent)
    }, 'Clustering')
  }
})

const MultiplePurchaseClusteringRoute = (store) => ({
  path: 'multiple-purchases-clustering-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const ClusteringComponent = require('./containers/MultiplePurchasesClusteringContainer.js').default
      const {loadAnalysisResultReducer} = require('./modules/Clustering')
      injectReducer(store, {key: 'analysisResult', reducer: loadAnalysisResultReducer})
      callback(null, ClusteringComponent)
    }, 'Clustering')
  }
})

const BillPurchaseClusteringRoute = (store) => ({
  path: 'purchases-clustering-analytics',
  isDemoAllowed: true,
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const ClusteringComponent = require('./containers/CustomerPurchasesClusteringContainer.js').default
      const {loadAnalysisResultReducer, loadClustersThresholdResultReducer} = require('./modules/Clustering')
      const {loadOpportunitiesReducer} = require('../Opportunities/modules/Opportunities')
      injectReducer(store, {key: 'opportunities', reducer: loadOpportunitiesReducer})
      injectReducer(store, {key: 'analysisResult', reducer: loadAnalysisResultReducer})
      injectReducer(store, {key: 'clustersThresholdResult', reducer: loadClustersThresholdResultReducer})
      callback(null, ClusteringComponent)
    }, 'Clustering')
  }
})

export {
  SinglePurchaseClusteringRoute,
  MultiplePurchaseClusteringRoute,
  BillPurchaseClusteringRoute
}



// WEBPACK FOOTER //
// ./src/routes/ClusteringAnalytics/index.js